<script setup lang="ts">
import VeeCheckbox from '@/components/forms/Checkbox/VeeCheckbox.vue';
import VeeNumberField from '@/components/forms/NumberField/VeeNumberField.vue';
import VeePasswordField from '@/components/forms/PasswordField/VeePasswordField.vue';
import VeeTextField from '@/components/forms/TextField/VeeTextField.vue';

export interface EmailSettingsProps {
  showDescription?: boolean;
}

const { showDescription = true } = defineProps<EmailSettingsProps>();
</script>

<template>
  <div>
    <h4 class="mb-4">
      {{ $t('ConfigureAndTestEmailSettings') }}
    </h4>
    <p v-if="showDescription">
      {{ $t('EmailSettingsExplanationMsg') }}
    </p>

    <v-row class="mt-4">
      <v-col cols="12" lg="4">
        <VeeTextField
          name="defaultFromAddress"
          type="email"
          :label="$t('SenderEmail')"
          :placeholder="$t('Required')"
        />
        <VeeTextField
          name="defaultFromDisplayName"
          :label="$t('SenderName')"
          :placeholder="$t('Required')"
          class="gutterTop"
        />
      </v-col>
      <v-col cols="12" lg="4">
        <div class="d-flex ga-4">
          <VeeTextField
            name="smtpHost"
            :label="$t('Host')"
            :placeholder="$t('Required')"
            class="flex-grow-1 w-75"
          />
          <VeeNumberField
            name="smtpPort"
            class="flex-grow-1 w-25"
            :label="$t('Port')"
            :placeholder="$t('Required')"
          />
        </div>
        <VeeCheckbox name="smtpEnableSsl" :label="$t('EnableSsl')" />
      </v-col>
      <v-col cols="12" lg="4">
        <VeeTextField name="smtpUserName" :label="$t('Username')" />
        <VeePasswordField name="smtpPassword" class="gutterTop" :label="$t('Password')" />
      </v-col>
    </v-row>
  </div>
</template>
